// extracted by mini-css-extract-plugin
module.exports = {"shadow":"range_shadow__2aaU_","textShadow":"range_textShadow__1AIDv","container":"range_container__1Bgs0"};